/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import { useSelector } from 'react-redux';
import { IState } from '../../../../store';
import { pathOr } from 'ramda';
import { Thumbnail } from './Thumbnail';
import { trackTourCards } from './analytics/trackTourCards';
import { Icon3d } from './Icons/Icon3d';

export const virtualTourSelector = (state: IState): string | null => {
  return pathOr(null, ['offerData', 'tourV2', 'tour', 'thumbnail'], state);
};

export const VirtualTourThumbnailContainer = () => {
  const tourThumbnail = useSelector(virtualTourSelector);

  if (!tourThumbnail) {
    return null;
  }

  const planHandler = React.useCallback(() => {
    trackTourCards('3dtour_photo_block');
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    document.getElementById('tourBlock')!.scrollIntoView({ block: 'center' });
  }, []);

  return <Thumbnail onClick={planHandler} img={tourThumbnail} text="3D-тур" icon={<Icon3d />} />;
};

VirtualTourThumbnailContainer.displayName = 'VirtualTourThumbnailContainer';
